import { render, staticRenderFns } from "./limitedStatus.vue?vue&type=template&id=06bb7ae5&scoped=true&"
import script from "./limitedStatus.vue?vue&type=script&lang=ts&"
export * from "./limitedStatus.vue?vue&type=script&lang=ts&"
import style0 from "./limitedStatus.vue?vue&type=style&index=0&id=06bb7ae5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb7ae5",
  null
  
)

export default component.exports